import { Input } from "@/components/ui/input";

export interface MoneyInputProps {
  /** Current value in MINOR units (öre). null/undefined → empty field. */
  valueMinor: number | null | undefined;
  /** Emits the new value in MINOR units (öre); 0 when cleared. (onValueChange, never onChange.) */
  onValueChange: (minor: number) => void;
  placeholder?: string;
  className?: string;
  id?: string;
  "data-testid"?: string;
}

/**
 * SEK money input. Displays kronor, stores/emits MINOR units (öre) — the canonical money unit.
 * Mirrors the NumberInput onValueChange contract (no onChange leak to callers).
 */
export function MoneyInput({
  valueMinor,
  onValueChange,
  placeholder = "0",
  className,
  id,
  ...rest
}: MoneyInputProps) {
  const kr = valueMinor != null ? String(valueMinor / 100) : "";
  return (
    <div className="relative">
      <Input
        id={id}
        type="number"
        min={0}
        step="1"
        inputMode="decimal"
        value={kr}
        placeholder={placeholder}
        className={className}
        onChange={(e) => {
          const v = e.target.value;
          if (v === "") {
            onValueChange(0);
            return;
          }
          const krNum = parseFloat(v);
          onValueChange(Number.isFinite(krNum) && krNum > 0 ? Math.round(krNum * 100) : 0);
        }}
        {...rest}
      />
      <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-xs text-muted-foreground">
        kr
      </span>
    </div>
  );
}

export default MoneyInput;
